module.exports = __webpack_public_path__ + "img/shop-bg.e5afd9a2.png";